// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 10 hooks for backend/performance.

import { useBackend } from '../useBackend'

/** POST /api/performance/createDriverBoardInvite */
export function useCreateDriverBoardInvite<T = any>() {
  return useBackend<T>('performance/createDriverBoardInvite')
}

/** POST /api/performance/getCompetitionApproval */
export function useGetCompetitionApproval<T = any>() {
  return useBackend<T>('performance/getCompetitionApproval')
}

/** POST /api/performance/getCompetitionLeaderboard */
export function useGetCompetitionLeaderboard<T = any>() {
  return useBackend<T>('performance/getCompetitionLeaderboard')
}

/** POST /api/performance/getCompetitionRuleProposals */
export function useGetCompetitionRuleProposals<T = any>() {
  return useBackend<T>('performance/getCompetitionRuleProposals')
}

/** POST /api/performance/getDriverCoaching */
export function useGetDriverCoaching<T = any>() {
  return useBackend<T>('performance/getDriverCoaching')
}

/** POST /api/performance/getManagers */
export function useGetManagers<T = any>() {
  return useBackend<T>('performance/getManagers')
}

/** POST /api/performance/getPerformance */
export function useGetPerformance<T = any>() {
  return useBackend<T>('performance/getPerformance')
}

/** POST /api/performance/getShiftPerformance */
export function useGetShiftPerformance<T = any>() {
  return useBackend<T>('performance/getShiftPerformance')
}

/** POST /api/performance/getVehicles */
export function useGetVehicles<T = any>() {
  return useBackend<T>('performance/getVehicles')
}

/** POST /api/performance/getZoneGuide */
export function useGetZoneGuide<T = any>() {
  return useBackend<T>('performance/getZoneGuide')
}
